import type { SeriesInstanceUid } from '~/domain/dicom/uids';
import type { ReadonlyVec3 } from 'gl-matrix';
import type { DatasetEnvironmentRegistry } from '~/engine/scene/DatasetEnvironmentRegistry';
import type { ViewManager } from '~/engine/view/ViewManager';
import { focusViewsOf } from './focusViewsOf';

/**
 * Frames every tile of the image series `seriesUid` on a patient-space
 * point (mm), each tile in its own plane (see {@link focusViewsOf}): for
 * point-type ROIs (MARKER, ISOCENTER, REGISTRATION) and maxima, which have
 * no contour bounding box to fit.
 * @returns Whether a tile shows the image: false when the series is not
 *   resident or no tile shows it.
 */
export function focusGridPoint(
    registry: DatasetEnvironmentRegistry,
    viewManager: ViewManager | null,
    seriesUid: SeriesInstanceUid | undefined,
    point: ReadonlyVec3
): boolean {
    const target = focusViewsOf(registry, viewManager, seriesUid);
    if (!target) {
        return false;
    }
    target.environment.panZoom.focusViewsToPoint(target.views, point);
    return true;
}
